export default "__VITE_ASSET__D2ay_erv__"